import { render, staticRenderFns } from "./ProviderLayout.vue?vue&type=template&id=32f117d4"
import script from "./ProviderLayout.vue?vue&type=script&lang=js"
export * from "./ProviderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports